!function(){
  "use strict";
  const t="[data-section-type]";
  customElements.get("recently-viewed") ||
  customElements.define("recently-viewed",class extends HTMLElement{
    constructor(){
      super(),
      this.section=this.closest(t),
      this.howManyToShow=parseInt(this.dataset.limit)||3,
      this.target=this.dataset.target,
      this.wrapperId=this.dataset.wrapperId||this.id
    }
    connectedCallback(){
      if(typeof Shopify.Products.showRecentlyViewed==="function"){
        const originalShow = Shopify.Products.showRecentlyViewed;
        Shopify.Products.showRecentlyViewed = function(options){
          let products = typeof getRecentlyViewed==="function" ? getRecentlyViewed() : [];
          const seen = new Set();
          products = products.filter(function(product){
            const id = product.handle || product.id || product.product_handle || product.product_id;
            if(seen.has(id)) return false;
            seen.add(id);
            return true;
          });
          if(options && options.howManyToShow)
            products = products.slice(0, options.howManyToShow);
          // Call the original render method with deduped products
          if(typeof options === "object" && typeof options.onComplete === "function"){
            options.products = products;
            originalShow.call(Shopify.Products, options);
          }else{
            originalShow.call(Shopify.Products, options);
          }
        }
      }
      Shopify.Products.showRecentlyViewed({
        howManyToShow:this.howManyToShow,
        wrapperId:this.wrapperId,
        section:this.section,
        target:this.target,
        onComplete:()=>{
          this.dispatchEvent(new CustomEvent("theme:recently-viewed:loaded",{bubbles:!1}))
        }
      });
    }
  });
}();
